/* eslint-disable react/prop-types */

import { Button, Form, ListGroup, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import BankAccountService from "../../service/bank-account-service";
import PaymentOrderService from "../../service/payment-order-service";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";

const bankAccountService = new BankAccountService();
const paymentOrderService = new PaymentOrderService();

await loadDictionary("payment-methods");
await loadDictionary("payment-reasons");
await loadDictionary("payment-order-payment-window");

function PaymentWindow({isOpenWindow, onCloseWindow, paymentOrders}) {
    const [originBankAccounts, setOriginBankAccounts] = useState([]);
    const [originBankAccountId, setOriginBankAccountId] = useState();
    const [paymentMethod, setPaymentMethod] = useState(Object.keys(i18n.t("payment-methods"))[0]);
    const [paymentReason, setPaymentReason] = useState(Object.keys(i18n.t("payment-reasons"))[0]);
    const paymentMethods = Object.entries(i18n.t("payment-methods"));
    const paymentReasons = Object.entries(i18n.t("payment-reasons"));
    const totalPaymentAmount = Array(paymentOrders).length && paymentOrders.reduce((previousValue, current) => previousValue + Number(current.amount), 0);

    const handleClose = () => {
        onCloseWindow(false);
    };

    const handleSubmit = () => {
        const payload = {
            "origin_bank_account_id": originBankAccountId,
            "payment_method": paymentMethod,
            "payment_reason": paymentReason,
            "payment_orders": paymentOrders.map(paymentOrder => paymentOrder.id)
        };

        paymentOrderService.pay(payload).then(() => {
            handleClose();
        });
    };
    
    useEffect(() => {
        if(!isOpenWindow || !paymentOrders || Array(paymentOrders).length === 0) {
            return;
        }

        bankAccountService.findAll().then(bankAccounts => {
            setOriginBankAccounts(bankAccounts.filter(bankAccount => bankAccount.party_id == null && bankAccount.type == "bank_account"));
        });
    }, [isOpenWindow, paymentOrders]);

    useEffect(() => {
        if(originBankAccounts.length) {
            setOriginBankAccountId(originBankAccounts[0]?.id);
        }
    }, [originBankAccounts]);

    return (
        <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{i18n.t("payment-order-payment-window.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form method="POST" id="ChargeBonCardForm" onSubmit={e => {e.preventDefault(); handleSubmit();}}>
                    <div className="row">
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-payment-window.origin_bank_account")}</Form.Label>
                            <Form.Select autoFocus value={originBankAccountId} onChange={e => {setOriginBankAccountId(e.target.value)}}>
                                {originBankAccounts.map((bankAccount) => <option key={bankAccount.id} value={bankAccount.id}>{bankAccount.name} {bankAccount.account_number}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="row">
                        <Form.Group className="col-6 mb-3">
                            <Form.Label>{i18n.t("payment-order-payment-window.payment_method")}</Form.Label>
                            <Form.Select value={paymentMethod} onChange={e => {setPaymentMethod(e.target.value)}}>
                                {paymentMethods.map((item) => <option key={item[0]} value={item[0]}>{item[1]}</option>)}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="col-6 mb-3">
                            <Form.Label>{i18n.t("payment-order-payment-window.payment_reason")}</Form.Label>
                            <Form.Select value={paymentReason} onChange={e => {setPaymentReason(e.target.value)}}>
                                {paymentReasons.map((item) => <option key={item[0]} value={item[0]}>{item[1]}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="row">
                        <Form.Group className="col mb-3">
                            <Form.Label>{i18n.t("payment-order-payment-window.selected_order_payment_list")}</Form.Label>
                            <ListGroup as="ul" dir="ltr" className="pe-0">
                            {Array(paymentOrders).length && paymentOrders.map((paymentOrder) => (
                                <ListGroup.Item as="li" key={paymentOrder.id} className="d-flex justify-content-between align-items-top">
                                    <div className="ms-auto">
                                        <div className="">{paymentOrder.party.name}</div>
                                        <span className="text-secondary">{paymentOrder.party_bank_account.iban}</span>
                                    </div>
                                    <div className="me-3">
                                        <div className="fw-bold">{Number(paymentOrder.amount).toLocaleString()}</div>
                                        <span className="text-secondary">{paymentOrder.party_bank_account.bank.name}</span>
                                    </div>
                                </ListGroup.Item>
                            ))}
                            </ListGroup>
                        </Form.Group>
                    </div>
                </Form>
                <p className="text-info-emphasis fw-bold">{i18n.t("payment-order-payment-window.total_amount_notice", {amount: totalPaymentAmount.toLocaleString()})}</p>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>{i18n.t("payment-order-payment-window.cancel_button")}</Button>
                <Button variant="primary" type="submit" form="ChargeBonCardForm" >{i18n.t("payment-order-payment-window.payment_button")}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PaymentWindow;